<template>
  <div class="collection-bar">
    <v-data-table
      must-sort
      width="100%"
      :height="tableHeight"
      :style="{ 'height': `${tableHeight}px` }"
      dense
      :items="items"
      :loading="loading"
      :scrollBusy="scrollBusy"
      :footer-props="footerProps"
      hide-default-footer
      hide-default-header
      :server-items-length="count"
      class="dataTable elevation-1 data-table"
      no-data-text="Нет данных"
    >
      <template v-slot:body="{ items }">
        <tbody v-infinite-scroll="more" infinite-scroll-disabled="scrollBusy" infinite-scroll-distance="1">
          <tr align="start" v-for="item in items" :key="item.id">
            <td width="400" @click="go(item)" :class="{ active : activeEl == item.id }">
              <span>{{ item.name| truncate_end(35, ' ..') }}</span>
            </td>
          </tr>
          <tr>
            <td align="center" v-if="scrollBusy && loading">
              <v-progress-circular :size="20" indeterminate class="primary--text"/>
            </td>
          </tr>
          <tr>
            <td v-if="items.length == 0">
              <span class="grey--text">Нет результатов</span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
export default {
  components: {
    infiniteScroll
  },
  name: 'StaticTabs',
  props: ['id', 'items', 'loading', 'scrollBusy', 'count'],
  computed: {
    tableHeight () {
      return this.$store.getters.height - 125
    },
    headers () {
      return [
        { text: 'Название', align: 'left', sortable: false, value: 'name' },
      ]
    },
    footerProps () {
      return {
        'items-per-page-options': [20, 50, 100, { text: 'All', value: null }]
      }
    }
  },
  data: function () {
    return {
      activeEl: this.id
    }
  },
  methods: {
    more ($state) {
      this.$emit('loadCollbar')
    },
    go (item) {
      this.activeEl = item.id
      if (this.$route.name.endsWith('view')) {
        this.$emit('toView', item, true)
      } else {
        this.$emit('toEdit', item, true)
      }
    }
  }
}
</script>
<style scoped>
.collection-bar {
  border-left: 1px solid #E8E8E8;
}
tbody tr {
  cursor: pointer;
}
tbody tr:nth-of-type(odd) {
 background-color: rgba(0, 0, 0, .05);
}
tbody tr:hover {
  background-color: #E8E8E8 !important;
}
.active {
  background-color: #607d8b !important;
  color: white;
}
</style>
